import { useEffect, useState, useCallback } from "react";
import { UserPlus, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ferr, Table } from "../shared";

export default function StaffPanel() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/staff"); setRows(data); }
    catch (e) { ferr(e, "Failed to load staff."); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/admin/staff", f); toast.success("Support account created."); setF({ name: "", email: "", password: "" }); load(); }
    catch (e) { ferr(e, "Could not create account."); } finally { setBusy(false); }
  };
  const remove = async (u) => {
    if (!window.confirm(`Remove ${u.email}?`)) return;
    try { await api.delete(`/admin/staff/${u.user_id}`); toast.success("Removed."); load(); }
    catch (e) { ferr(e, "Remove failed."); }
  };
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="admin-staff">
      <div className="lg:col-span-2">
        <Table cols={["Email", "Name", "Role", ""]} loading={loading} empty={!rows.length}>
          {rows.map((u) => (
            <tr key={u.user_id} className="border-t border-gravel" data-testid={`admin-staff-row-${u.user_id}`}>
              <td className="td">{u.email}</td>
              <td className="td">{u.name}</td>
              <td className="td">{u.role}</td>
              <td className="td text-right">{u.role === "support" && <button onClick={() => remove(u)} className="icon-btn text-rose-600" data-testid={`admin-staff-delete-${u.user_id}`}><Trash2 size={15} /></button>}</td>
            </tr>
          ))}
        </Table>
      </div>
      <form onSubmit={create} className="card-mtr space-y-3 h-fit" data-testid="admin-staff-form">
        <h3 className="font-bold text-navy text-[15px] flex items-center gap-2"><UserPlus size={18} /> New support account</h3>
        <input className="input-mtr" placeholder="Full name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="admin-staff-name" />
        <input className="input-mtr" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-staff-email" />
        <input className="input-mtr" type="password" placeholder="Temp password (min 8)" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-staff-password" />
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-staff-create"><Plus size={16} /> Create</button>
      </form>
    </div>
  );
}
